'use client';

import { Suspense } from 'react';

import Calculator from '@/components/Calculator';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import ZapChat from '@/components/ZapChat';
import '@/styles/calculator.css';
import '@/styles/headerfooter.css';

export default function CalculatorPage() {
  return (
    <>
      <ZapChat />
      <main id="main-content" className="min-h-screen pt-24">
        <Suspense
          fallback={
            <div className="fixed top-0 right-0 left-0 z-50 h-[72px] border-black/5 border-b bg-white shadow-sm" />
          }
        >
          <Header />
        </Suspense>

        <Calculator theme="light" />

        <Footer />
      </main>
    </>
  );
}
